var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 23,
  height: 23,
  viewBox: "0 0 23 23"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_5477",
  "data-name": "Group 5477",
  transform: "translate(-4632 -2377.499)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_349",
  "data-name": "Ellipse 349",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  transform: "translate(4632 2377.499)",
  fill: "#2bc822"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_364",
  "data-name": "Path 364",
  d: "M0,0H14.687",
  transform: "translate(4638.491 2392.224) rotate(-30)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_365",
  "data-name": "Path 365",
  d: "M0,0H4.406",
  transform: "translate(4636.288 2388.409) rotate(60)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2
}))));
export default __webpack_public_path__ + "static/media/greenroundcorrect.e7a4c17f.svg";
export { SvgComponent as ReactComponent };